import React, { useState } from 'react';
import {Button, Center, Container, Group, Indicator, Loader, Modal, Tooltip} from '@mantine/core';
import { IconCirclePlus, IconCircleX, IconEdit } from '@tabler/icons-react';
import {
  AimNote, useAimContext,
  useDeleteNoteMutation,
  useLazyNotesQuery,
  useNewNoteMutation,
  useUpdateNoteMutation
} from '@repo/services';
import {errorBoundaryWrapper, useAgLazyQuery, useAgMutation, useNotes} from '@repo/utils';
import { useParams } from 'react-router';
import FullHeightLoader from '../../FullHeightLoader';
import { useDisclosure } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';
import FullHeightLoadingOverlay from '../../FullHeightLoadingOverlay';
import ModalContent from './ModalContent'; // for snow theme
import classes from './Notes.module.css';

const Notes = ({ id: aimId, isNew = false, inline = false }: { id: string | undefined; isNew?: boolean; inline?: boolean }) => {
  let { id } = useParams();
  if (aimId && aimId !== "0") id = aimId;
  const [opened, { open, close }] = useDisclosure(false);
  const { entityNotes } = useAimContext();
  const [notes, notesLoading, notesIsSuccess, notesFetching] = useAgLazyQuery(id, useLazyNotesQuery);

  const { trigger: triggerCreateNewNote, isLoading: createNewIsLoading } = useAgMutation<AimNote>(
    useNewNoteMutation,
    () => {
      notifications.show({
        title: 'Note Created',
        message: `Your note was created successfully!`
      });
    }
  );
  const { trigger: triggerUpdateNote, isLoading: updateIsLoading } = useAgMutation<AimNote>(
    useUpdateNoteMutation,
    () => {
      notifications.show({
        title: 'Note Updated',
        message: `Your note was updated successfully!`
      });
    }
  );
  const { trigger: triggerDeleteNote, isLoading: deleteIsLoading } = useAgMutation<AimNote>(
    useDeleteNoteMutation,
    () => {
      notifications.show({
        title: 'Note Deleted',
        message: `Your note was deleted successfully!`
      });
    }
  );

  const [showForm, setShowForm] = useState<boolean>(false);

  //
  // if (notesFetching || notesLoading)
  //   return (
  //     <Center mt={'40%'} h={'100%'}>
  //       <Loader />
  //     </Center>
  //   );
  return (
    <>
      <Modal.Root zIndex={300} opened={opened} onClose={createNewIsLoading ? () => {} : close} size={'70rem'}>
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title>Notes</Modal.Title>
            {!showForm && (
              <Group gap='xs'>
                <Button color='gray' leftSection={<IconCircleX />} onClick={close}>
                  Close
                </Button>
                <Button leftSection={<IconCirclePlus />} onClick={() => setShowForm(true)}>
                  New Note
                </Button>
              </Group>
            )}
          </Modal.Header>
          <Modal.Body>
            <Container p={10} style={{ height: '90%' }}>
              {notesLoading && <FullHeightLoader message={'Fetching notes...'} />}
              <FullHeightLoadingOverlay visible={createNewIsLoading || updateIsLoading || deleteIsLoading} />
              {((notesIsSuccess &&
                !notesLoading &&
                !createNewIsLoading &&
                !updateIsLoading &&
                !deleteIsLoading) || (isNew)) && (
                  <ModalContent
                    id={isNew ? '0' : id}
                    triggerCreateNewNote={triggerCreateNewNote}
                    triggerDeleteNote={triggerDeleteNote}
                    triggerUpdateNote={triggerUpdateNote}
                    showForm={showForm}
                    setShowForm={setShowForm}
                    notes={notes}
                    isNew={isNew}
                  />
                )}
            </Container>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
      {inline ? (
        <ModalContent
          id={id}
          triggerCreateNewNote={triggerCreateNewNote}
          triggerDeleteNote={triggerDeleteNote}
          triggerUpdateNote={triggerUpdateNote}
          showForm={showForm}
          setShowForm={setShowForm}
          notes={notes}
        />
      ) : (
        <Tooltip label="Notes">
          <Indicator inline classNames={classes} label={isNew ? entityNotes?.length :notes?.length} disabled={isNew ? entityNotes?.length === 0 : !notes || notes?.length === 0} size={16}>
            <Button mr={8} onClick={open} variant='default'>
              <IconEdit />
            </Button>
          </Indicator>
        </Tooltip>
      )}
    </>
  );
};

export default errorBoundaryWrapper(Notes);
